import { render, staticRenderFns } from "./showPollAnswerStatistics.vue?vue&type=template&id=bf036510&"
import script from "./showPollAnswerStatistics.vue?vue&type=script&lang=js&"
export * from "./showPollAnswerStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports